// extracted by mini-css-extract-plugin
export default {"form":"SendMessageForm_form__tt-nh","input":"SendMessageForm_input__kfPPR"};